// Money Machine Enhancements for Agent Gator Store
document.addEventListener('DOMContentLoaded', function() {
  
  // Add collection navigation badges below hero banner
  addCollectionNavigation();
  
  // Add hot badges to products
  addHotBadges();
  
  // Enhance buttons and call-to-actions
  enhanceButtons();
  
  // Make featured collections more prominent
  enhanceFeaturedCollections();
  
  // Add quick view functionality
  addQuickViewButtons();
  
  // Enhance newsletter signup
  enhanceNewsletter();
  
  // Add scroll-to-top button
  addScrollToTop();
});

// Add collection navigation badges
function addCollectionNavigation() {
  // Only add to homepage
  if (!window.location.pathname.match(/^\/$|^\/\?/)) return;
  
  // Check if we already have the collection navigation
  if (document.querySelector('.custom-collection-navigation')) return;
  
  // Find a good spot to inject the navigation - right after the first section
  const firstSection = document.querySelector('main > .shopify-section:first-child');
  if (!firstSection) return;
  
  // Create collection navigation HTML
  const collectionNav = document.createElement('div');
  collectionNav.className = 'custom-collection-navigation';
  collectionNav.innerHTML = `
    <div class="page-width">
      <h2 class="section-title">SHOP BY CATEGORY</h2>
      <div class="collection-badges">
        <a href="/collections/holiday-gifts" class="collection-badge">Holiday Gifts</a>
        <a href="/collections/hot-gator-gear" class="collection-badge">Hot Gator Gear</a>
        <a href="/collections/shirts" class="collection-badge">Shirts</a>
        <a href="/collections/mugs-drinkware" class="collection-badge">Mugs & Drinkware</a>
        <a href="/collections/tote-bags" class="collection-badge">Tote Bags</a>
        <a href="/collections/hats-caps" class="collection-badge">Hats & Caps</a>
        <a href="/collections/hoodies-sweatshirts" class="collection-badge">Hoodies & Sweatshirts</a>
      </div>
    </div>
  `;
  
  // Insert after first section
  firstSection.after(collectionNav);
}

// Add "Hot" badges to product cards
function addHotBadges() {
  // Only add hot badges to certain products (you would customize this logic)
  const productCards = document.querySelectorAll('.card--product');
  
  if (productCards.length === 0) return;
  
  // Add hot badge to first 4 products for demo purposes
  for (let i = 0; i < productCards.length && i < 4; i++) {
    const card = productCards[i];
    
    // Skip if badge already exists
    if (card.querySelector('.hot-badge')) continue;
    
    const hotBadge = document.createElement('div');
    hotBadge.className = 'hot-badge';
    hotBadge.innerText = 'HOT';
    
    // Add the badge to the product card
    card.appendChild(hotBadge);
  }
}

// Enhance buttons and calls-to-action
function enhanceButtons() {
  // Find all buttons
  const buttons = document.querySelectorAll('.button, .product-form__submit, .cart__checkout-button');
  
  buttons.forEach(button => {
    // Add hover effect if not already applied
    if (!button.classList.contains('button--enhanced')) {
      button.classList.add('button--enhanced');
      
      // Add hover event listener
      button.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-3px)';
        this.style.boxShadow = '0 7px 14px rgba(0, 0, 0, 0.15)';
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = 'translateY(0)';
        this.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
      });
    }
  });
}

// Enhance featured collections
function enhanceFeaturedCollections() {
  const featuredCollections = document.querySelectorAll('.collection');
  
  featuredCollections.forEach(collection => {
    // Add section title enhancement
    const title = collection.querySelector('.title');
    if (title && !title.classList.contains('title--enhanced')) {
      title.classList.add('title--enhanced');
      title.style.fontSize = '2.5rem';
      title.style.fontWeight = 'bold';
      title.style.textTransform = 'uppercase';
      title.style.marginBottom = '1.5rem';
    }
    
    // Enhance product cards
    const cards = collection.querySelectorAll('.card');
    cards.forEach(card => {
      if (!card.classList.contains('card--enhanced')) {
        card.classList.add('card--enhanced');
        card.style.transition = 'all 0.3s ease';
        card.style.borderRadius = '8px';
        card.style.overflow = 'hidden';
        card.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.08)';
        
        card.addEventListener('mouseenter', function() {
          this.style.transform = 'translateY(-5px)';
          this.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.15)';
        });
        
        card.addEventListener('mouseleave', function() {
          this.style.transform = 'translateY(0)';
          this.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.08)';
        });
      }
    });
  });
}

// Add quick view buttons
function addQuickViewButtons() {
  const productCards = document.querySelectorAll('.card--product');
  
  productCards.forEach(card => {
    // Skip if quick view already exists
    if (card.querySelector('.quick-view-button')) return;
    
    // Create quick view button
    const quickViewBtn = document.createElement('button');
    quickViewBtn.className = 'quick-view-button';
    quickViewBtn.innerText = 'QUICK VIEW';
    
    // Style the button
    quickViewBtn.style.position = 'absolute';
    quickViewBtn.style.bottom = '15px';
    quickViewBtn.style.left = '50%';
    quickViewBtn.style.transform = 'translateX(-50%) translateY(100%)';
    quickViewBtn.style.backgroundColor = '#242833';
    quickViewBtn.style.color = '#ffffff';
    quickViewBtn.style.padding = '8px 16px';
    quickViewBtn.style.borderRadius = '4px';
    quickViewBtn.style.border = 'none';
    quickViewBtn.style.fontWeight = 'bold';
    quickViewBtn.style.textTransform = 'uppercase';
    quickViewBtn.style.fontSize = '12px';
    quickViewBtn.style.cursor = 'pointer';
    quickViewBtn.style.transition = 'all 0.3s ease';
    quickViewBtn.style.opacity = '0';
    quickViewBtn.style.zIndex = '2';
    
    // Add hover effect to card to show the button
    card.style.position = 'relative';
    card.style.overflow = 'hidden';
    
    card.addEventListener('mouseenter', function() {
      quickViewBtn.style.transform = 'translateX(-50%) translateY(0)';
      quickViewBtn.style.opacity = '1';
    });
    
    card.addEventListener('mouseleave', function() {
      quickViewBtn.style.transform = 'translateX(-50%) translateY(100%)';
      quickViewBtn.style.opacity = '0';
    });
    
    // Add button to card
    card.appendChild(quickViewBtn);
  });
}

// Enhance newsletter signup
function enhanceNewsletter() {
  const newsletter = document.querySelector('.newsletter');
  
  if (!newsletter) return;
  
  // Enhance newsletter background
  if (!newsletter.classList.contains('newsletter--enhanced')) {
    newsletter.classList.add('newsletter--enhanced');
    
    // Add gradient background
    newsletter.style.background = 'linear-gradient(135deg, #242833 0%, #334fb4 100%)';
    newsletter.style.position = 'relative';
    
    // Add pattern overlay
    const patternOverlay = document.createElement('div');
    patternOverlay.className = 'newsletter-pattern-overlay';
    patternOverlay.style.position = 'absolute';
    patternOverlay.style.top = '0';
    patternOverlay.style.left = '0';
    patternOverlay.style.width = '100%';
    patternOverlay.style.height = '100%';
    patternOverlay.style.opacity = '0.05';
    patternOverlay.style.backgroundSize = '150px';
    patternOverlay.style.pointerEvents = 'none';
    
    newsletter.insertBefore(patternOverlay, newsletter.firstChild);
    
    // Enhance form appearance
    const form = newsletter.querySelector('form');
    if (form) {
      form.style.position = 'relative';
      form.style.zIndex = '1';
      form.style.maxWidth = '600px';
      form.style.margin = '0 auto';
    }
    
    // Enhance submit button
    const submitButton = newsletter.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.style.backgroundColor = '#242833';
      submitButton.style.color = '#ffffff';
      submitButton.style.fontWeight = 'bold';
      submitButton.style.textTransform = 'uppercase';
      submitButton.style.letterSpacing = '0.05em';
      submitButton.style.padding = '0 2rem';
      
      submitButton.addEventListener('mouseenter', function() {
        this.style.backgroundColor = '#334fb4';
        this.style.transform = 'translateY(-2px)';
      });
      
      submitButton.addEventListener('mouseleave', function() {
        this.style.backgroundColor = '#242833';
        this.style.transform = 'translateY(0)';
      });
    }
  }
}

// Add scroll-to-top button
function addScrollToTop() {
  // Check if button already exists
  if (document.querySelector('.scroll-to-top-button')) return;
  
  // Create scroll-to-top button
  const scrollTopBtn = document.createElement('button');
  scrollTopBtn.className = 'scroll-to-top-button';
  scrollTopBtn.innerHTML = '&#9650;';
  
  // Style the button
  scrollTopBtn.style.position = 'fixed';
  scrollTopBtn.style.bottom = '20px';
  scrollTopBtn.style.right = '20px';
  scrollTopBtn.style.width = '50px';
  scrollTopBtn.style.height = '50px';
  scrollTopBtn.style.borderRadius = '50%';
  scrollTopBtn.style.backgroundColor = '#242833';
  scrollTopBtn.style.color = '#ffffff';
  scrollTopBtn.style.border = 'none';
  scrollTopBtn.style.fontSize = '20px';
  scrollTopBtn.style.cursor = 'pointer';
  scrollTopBtn.style.display = 'none';
  scrollTopBtn.style.zIndex = '9999';
  scrollTopBtn.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
  scrollTopBtn.style.transition = 'all 0.3s ease';
  
  // Add hover effect
  scrollTopBtn.addEventListener('mouseenter', function() {
    this.style.backgroundColor = '#334fb4';
    this.style.transform = 'translateY(-3px)';
    this.style.boxShadow = '0 7px 14px rgba(0, 0, 0, 0.3)';
  });
  
  scrollTopBtn.addEventListener('mouseleave', function() {
    this.style.backgroundColor = '#242833';
    this.style.transform = 'translateY(0)';
    this.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
  });
  
  // Add click event
  scrollTopBtn.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
  
  // Show/hide button on scroll
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 300) {
      scrollTopBtn.style.display = 'block';
    } else {
      scrollTopBtn.style.display = 'none';
    }
  });
  
  // Add button to body
  document.body.appendChild(scrollTopBtn);
}